import axios from "axios";
import { apiCallFailed, apiCallStarted, apiCallSucceeded } from "./actions";
import AuthService from "src/_services/AuthService";

import { $BASE_URL } from "src/constants";
const baseUrl = $BASE_URL + '/api';

const api = ({ dispatch, getStore }) => (next) => async (action) => {
  if (action.type !== apiCallStarted.type) return next(action);

  const { url, method, data, onStart, onSuccess, onError, params } = action.payload;


  if (onStart) dispatch({ type: onStart });
  next(action);

  try {
    const jwt = AuthService.getJwt();
    const response = await axios.request({
      url: baseUrl + url,
      method,
      data,
      params,
      headers: { Authorization: `Bearer ${jwt}` },
    });
    // General
    dispatch(apiCallSucceeded(response.data));
    // Specific
    if (onSuccess) dispatch({ type: onSuccess, payload: response.data });
  } catch (error) {
    // General
    dispatch(apiCallFailed(error.message));
    // Specific
    if (onError) dispatch({ type: onError, payload: error?.message, status: error?.response?.status });
  }
};

export default api;
